/*
Prakash 02/17/2023 3225736869 Fixed Table Header Actions Alignments.
Suresh peddavoora 02-20-2023 3225736869 Fixed Table Data Alignments
Suresh peddavoora 02-22-2023 3225736869 Fixed new UI changes
Rohini 03-01-2023 3225736869 added the class name for the table
Raghu 03/02/2023 3225736869 fixed table alignmnents
Rohini 03/09/2023 3225736869 fixed table alignmnents.
T Santosh Kumar 24/03/2023 3225736869 Added the Icon
Prakash 04/06/2023 3225736869 remove margin top and fixed button issue
Akhila 04/19/2023 3225736869  table reusable in account summary
Akhila 06/05/2023 3225736869 bug fix preppropulation issue in account summary
Ravi 06/22/2023 3225736869 fixed submit issue
Uday  13/10/2023 3225736869 fixed table alignment issues
Gireesh 13/10/2023 5155351118 fixed table rows drag and drop issue
uday 06/12/2023 5155351118 add condtion classname table alignments issues
Sohel 07/12/2023 5155351118 Fixed Client Management Reset Issue
*/
import React, {createRef, useEffect, useState, useMemo} from 'react';
import {Button, Grid, makeStyles, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import reusableInputStyles from '../../../components/InputStyles';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../../components/DialogBox';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  getAddressDetails,
  getEditAddressDetails,
  postAddressListData,
  resetEditTableData,
  resetClientInfo,
  fetchAddressData,
} from '../../../redux/reducers/clientMangement/Organizaation';
import AddressForm from './AddressForm';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddIcon from '@material-ui/icons/AddOutlined';
import {MTableBody, MTableBodyRow} from 'material-table';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const useStyles = makeStyles({
  letterTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'flex',
      outline: 0,
      verticalAlign: 'middle',
    },

    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
    '& .MuiTableBody-root': {
      display: 'inherit',
    },
  },
});
export default function searchTable({
  id,
  orgType,
  AccountSummary,
  clientInfoData,
  clientNumber,
  organizationAccess,
}) {
  const {errorMsg, successMsg, addressData, editAddressData, addressTableData} = useSelector(
    ({organization}) => organization,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const getApiData = useMemo(() => {
    if (addressTableData && addressTableData.length > 0) {
      return addressTableData.map((item) => ({...item}))?.sort((a, b) => a.seqNo - b.seqNo);
    }
    return [];
  }, [addressTableData]);
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        if (selectedRows?.length > 0) {
          selectedRows[rowData?.tableData?.id].seqNo = rowSeqNo;
        }
        return (
          <div className={ AccountSummary
            ? `account-seqno`:`seqno-client`}
          >
            {rowSeqNo}
          </div>
        );
      },
    },
    {
      title: 'Address Type',
      field: 'addressType',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "20px",
            }}
          >
            {rowData?.addressType ? rowData?.addressType : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Address Line 1',
      field: 'address1',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "23px",
            }}
          >
            {rowData?.address1 ? rowData?.address1 : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Address Line 2',
      field: 'address2',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "35px",
            }}
          >
            {rowData?.address2 ? rowData?.address2 : ''}
          </div>
        </>
      ),
    },
    {
      title: 'City',
      field: 'city',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "35px",
            }}
          >
            {rowData?.city ? rowData?.city : ''}
          </div>
        </>
      ),
    },
    {
      title: 'State',
      field: 'state',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "23px",
            }}
          >
            {rowData?.state ? rowData?.state : ''}
          </div>
        </>
      ),
    },

    {
      title: 'Zip Code',
      field: 'zip',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 100,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              // paddingLeft: "12px",
            }}
          >
            {rowData?.zip ? rowData?.zip : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Country',
      field: 'country',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: '300px',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.country}
          </div>
        </>
      ),
    },

    {
      title: 'Location Code',
      field: 'locationCode',
    },
    {
      title: 'Opt In',
      field: 'optInFlag',
    },
    {
      title: 'Address Flag',
      field: 'addressFlag',
    },
  ];

  useEffect(() => {
    if (addressData?.length > 0) {
      const data = [...addressData];
      data?.sort((a, b) => a['seqNo'] - b['seqNo']);
      const newData = data.map((item, i) => ({...item, seqNo: i + 1}));
      setSelectedRows(newData);
    } else if (getApiData?.length > 0) {
      const data = [...getApiData];
      data?.sort((a, b) => a['seqNo'] - b['seqNo']);
      const newData = data.map((item, i) => ({...item, seqNo: i + 1}));
      setSelectedRows(newData);
    } else {
      setSelectedRows([])
    }
  }, [addressData, getApiData]);

  const handleClose = () => {
    setOpen(false);
    dispatch(resetEditTableData());
  };
  useEffect(() => {
    if (AccountSummary && clientNumber) {
      dispatch(fetchAddressData(clientNumber));
    }
  }, [AccountSummary, clientNumber]);
  useEffect(() => {
    if (successMsg) {
      dispatch(getAddressDetails(id, orgType));
      handleClose();
      dispatch(resetClientInfo());
    }
  }, [successMsg]);

  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (source.index !== destination.index) {
      const copyRows = [...selectedRows];
      const temp = selectedRows[source.index];
      copyRows.splice(source.index, 1);
      copyRows.splice(destination.index, 0, temp);
      setSelectedRows(copyRows);
    }
  };

  return (
    <div className="add-address-table">
      <DialogBox
        open={open}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'lg'}
        title={editAddressData?.orgAddressId ? 'Edit Address Details' : `Add Address Details`}
      >
        <AddressForm handleClose={handleClose} id={id} type={orgType} selectedRows={selectedRows} />
      </DialogBox>
      <Grid item xs={12}>
        <div
          className={
            AccountSummary
              ? `mb-4 global-field-table custom-table ${classes1.letterTable} drag-and-drop-table custom-map-sec new-standard-textfields`
              : `mb-4 global-field-table custom-table ${classes1.letterTable} drag-and-drop-table custom-map-sec drawdrag-table new-standard-textfields action-icon`
          }
        >
          <GuiTable
            title={`Address Details`}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={
              selectedRows?.length > 0 ?
                selectedRows.map((item) => ({...item})) :
                getApiData ?
                  getApiData :
                  []
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'right',
              showTextRowsSelected: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              !AccountSummary && [
                {
                  icon: () => (
                    <>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        startIcon={<AddIcon />}
                        disabled={!organizationAccess?.edit}
                      >
                        Add Address Details
                      </Button>
                    </>
                  ),
                  disabled: !organizationAccess?.edit,
                  isFreeAction: true,
                  onClick: (event) => {
                    setOpen(true);
                  },
                },
                {
                  icon: () => <EditOutlinedIcon />,
                  tooltip: 'Edit',
                  disabled: !organizationAccess?.edit,
                  onClick: (event, rowData) => {
                    dispatch(getEditAddressDetails(rowData?.orgAddressId));
                    setOpen(true);
                  },
                },
              ]
            }
            components={{
              Body: (props) => (
                <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                      {(provided) => (
                        <div ref={provided.innerRef}>
                          <MTableBody {...props} />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              ),
              Row: (props) => (
                <Draggable
                  draggableId={props.data.tableData.id.toString()}
                  index={props.data.tableData.id}
                >
                  {(provided) => (
                    <div
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                    >
                      <MTableBodyRow {...props} />
                    </div>
                  )}
                </Draggable>
              ),
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
          />
        </div>
      </Grid>
      <div className="d-flex justify-content-center  new-standard-textfields">
        <Button
          variant="outlined"
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
          hidden={AccountSummary}
          onClick={() => {
            const data = [...addressData];
            data?.sort((a, b) => a['seqNo'] - b['seqNo']);
            const newData = data.map((item, i) => ({...item, seqNo: i + 1}));
            setSelectedRows(newData);
          }}
        >
          Reset
        </Button>
        <Button
          variant="outlined"
          type="button"
          disabled={!organizationAccess?.edit || enabledSubmission}
          hidden={AccountSummary}
          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
          onClick={() => {
            dispatch(submissionStart());
            dispatch(postAddressListData({organizationAddressListRequest: selectedRows}));
          }}
        >
          Save
        </Button>
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
